import { AFFECTED_BUNDLES_ACTIONS, initialAffectedBundlesState } from './affectedBundles.types'

/**
 * @param {import('./affectedBundles.types').AffectedBundlesSlice} state
 * @param {import('./affectedBundles.types').AffectedBundlesAction} action
 * @returns {import('./affectedBundles.types').AffectedBundlesSlice}
 */
export function affectedBundlesReducer(state = initialAffectedBundlesState, { type, payload }) {
  switch (type) {
    case AFFECTED_BUNDLES_ACTIONS.SET_AFFECTED_BUNDLES_STATUS:
      return {
        ...state,
        status: payload
      }

    case AFFECTED_BUNDLES_ACTIONS.SET_AFFECTED_BUNDLES_ERRORS:
      return {
        ...state,
        errors: payload
      }

    case AFFECTED_BUNDLES_ACTIONS.SET_AFFECTED_BUNDLES:
      return {
        ...state,
        count: payload.count,
        affectedBundles: payload.affectedBundles
      }

    default:
      return state
  }
}
